module.exports = __webpack_public_path__ + "img/frame.640db84f.png";